import styled from 'styled-components';
import { layout, colors } from 'src/components/base';
import { GridRow, GridColumn } from '@prisjakt/ui/list/variants';

export const CampaignListItem = styled(GridColumn)`
  text-align: center;
  border-color: ${colors.borderLightGray};
  border-style: solid;
  border-width: 1px;
  border-radius: ${layout.measurements.spacing050};
  padding: ${layout.measurements.spacing050};
`;

export const RowWithWrap = styled(GridRow)`
  flex-wrap: wrap;
  gap: ${layout.measurements.spacing400};
`;
